import { render, staticRenderFns } from "./fullscreen-loader.vue?vue&type=template&id=d10c81b6&scoped=true&"
import script from "./fullscreen-loader.vue?vue&type=script&lang=js&"
export * from "./fullscreen-loader.vue?vue&type=script&lang=js&"
import style0 from "./fullscreen-loader.vue?vue&type=style&index=0&id=d10c81b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10c81b6",
  null
  
)

export default component.exports